<template>
  <v-container fluid>
    <base-material-card color="primary" icon="mdi-graph" inline class="ml-0 px-5 py-4" title="Sequenciamento Elétrico">
      <v-btn
        v-if="accessReleased('SEQUENCIAMENTO_ELETRICO_ADICIONAR')"
        id="btn-novo-sequenciamento"
        color="success"
        dark
        elevation="1"
        class="mt-5"
        style="float: left"
        relative
        text
        medium
        @click="$router.push('add')"
      >
        <v-icon left size="30px">mdi-plus-circle</v-icon>
        Executar
      </v-btn>

      <v-text-field
        id="sequenciamentos-eletricos-historico-search"
        v-model="search"
        append-icon="mdi-magnify"
        class="break-search ml-auto mt-4"
        label="Procurar"
        hide-details
        single-line
        style="max-width: 250px"
      />
      <v-divider class="mt-10" />
      <v-data-table
        class="sequenciamentos-eletricos-table"
        :headers="headers"
        :items="items"
        :search.sync="search"
        :mobile-breakpoint="800"
        :loading="loading"
        :hide-default-header="loading"
        :hide-default-footer="loading"
        no-data-text="Nenhuma execução de sequenciamento elétrico encontrada"
      >
        <template v-slot:[`item.data_registro`]="{ item }">{{ item.data_registro | formatToMonth }} v{{ item.versao }}</template>
        <template v-slot:[`item.tipo_sequenciamento`]="{ item }">
          {{ item.tipo_sequenciamento | exibeTipoSequenciamento }}
        </template>
        <template v-slot:[`item.ctmts_selecionados`]="{ item }">
          <div class="clickable-item" @click="openDialogCtmtsSelecionados(item.ctmts_selecionados)">
            {{ item.ctmts_selecionados | exibeResumoCtmtsSelecionados }}
          </div>
        </template>
        <template v-slot:[`item.untrmts_selecionados`]="{ item }">
          <div
            v-if="item.untrmts_selecionados && item.untrmts_selecionados.length"
            class="clickable-item"
            @click="openDialogUntrmtsSelecionados(item.untrmts_selecionados)"
          >
            {{ item.untrmts_selecionados | exibeResumoUntrmtsSelecionados }}
          </div>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <general-status :status="item.status" />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            :class="!['SUCESSO', 'FALHA'].includes(item.status) ? 'cursor-block' : ''"
            class="px-1"
            min-width="0"
            fab
            icon
            x-small
            :loading="loadingLogsTecnicos[item.id]"
            :disabled="!['SUCESSO', 'FALHA'].includes(item.status)"
            @click="() => baixarLogsTecnicos(item.id)"
          >
            <v-icon small>mdi-download</v-icon>
          </v-btn>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                id="action-more"
                color="white"
                class="ml-1"
                height="22px"
                width="22px"
                fab
                x-small
                elevation="1"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon small>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="canExecuteItem(item.status)" @click="executeItem(item.id)">
                <v-list-item-title>
                  <v-icon small>mdi-play</v-icon>
                  Executar
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="canDeleteItem(item)" @click="openDialogDelete(item)">
                <v-list-item-icon class="mx-0 my-0 py-4">
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Deletar</v-list-item-title>
              </v-list-item>
              <v-list-item @click="openDialogCreationLog(item)">
                <v-list-item-title>
                  <v-icon small>mdi-table-search</v-icon>
                  Log
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <template v-slot:[`footer.page-text`]>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on" @click="$emit('rechargeTable')">mdi-refresh</v-icon>
            </template>
            <span>Clique aqui para recarregar as execuções de sequenciamento elétrico</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <dialog-creation-log :dialog.sync="dialogCreationLog" :item="dialogCreationLogData" />
    <v-dialog v-model="dialogCtmtsSelecionados" scrollable max-width="500px">
      <v-card>
        <v-card-title class="py-3" style="text-align: left !important">
          <h2>CTMTS selecionados</h2>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-3">
          <v-textarea
            class="ta-padding-c"
            rows="10"
            no-resize
            background-color="#EEEEEE"
            :readonly="true"
            :value="dialogCtmtsSelecionadosData.join('\n')"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions style="text-align: right !important; display: block !important">
          <v-btn color="green darken-1" @click="dialogCtmtsSelecionados = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogUntrmtsSelecionados" scrollable max-width="500px">
      <v-card>
        <v-card-title class="py-3" style="text-align: left !important">
          <h2>UNTRMTS selecionadas</h2>
        </v-card-title>
        <v-divider />
        <v-card-text class="py-3">
          <v-textarea
            class="ta-padding-c"
            rows="10"
            no-resize
            background-color="#EEEEEE"
            :readonly="true"
            :value="dialogUntrmtsSelecionadosData.join('\n')"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions style="text-align: right !important; display: block !important">
          <v-btn color="green darken-1" @click="dialogUntrmtsSelecionados = false">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-delete :dialog.sync="dialogDelete" @submitTriggered="deletarItem(dialogDeleteData.id)">
      <template slot="title">Deletar Sequenciamento #{{ dialogDeleteData.id }}</template>
      <template slot="body">
        Tem certeza que deseja deletar a execução de sequenciamento elétrico
        <strong>#{{ dialogDeleteData.id }}</strong>
        ?
      </template>
    </dialog-delete>
  </v-container>
</template>

<script>
  import SequenciamentoEletricoService from '@/services/SequenciamentoEletricoService';
  import powerupsActionsMixins from '@/mixins/powerupsActionsMixins.js';
  import profilePermissionsMixin from '@/mixins/profilePermissionsMixin';

  export default {
    components: {
      DialogCreationLog: () => import('@/components/general/DialogCreationLog'),
      DialogDelete: () => import('@/components/general/DialogDelete'),
      GeneralStatus: () => import('@/components/general/GeneralStatus.vue')
    },
    filters: {
      exibeResumoCtmtsSelecionados(arrayCtmts) {
        let formattedValue = arrayCtmts[0].toUpperCase();
        let lengthArray = arrayCtmts.length;
        formattedValue = lengthArray > 1 ? `${formattedValue} + ${lengthArray - 1}` : formattedValue;
        return formattedValue;
      },
      exibeResumoUntrmtsSelecionados(arrayUntrmts) {
        let formattedValue = arrayUntrmts[0].toUpperCase();
        let lengthArray = arrayUntrmts.length;
        formattedValue = lengthArray > 1 ? `${formattedValue} + ${lengthArray - 1}` : formattedValue;
        return formattedValue;
      },
      exibeTipoSequenciamento(tipo) {
        const labels = {
          COMPLETO: 'Completo (MT + BT)',
          MT: 'Somente MT',
          BT: 'Somente BT'
        };

        return labels[tipo] || 'Completo (MT + BT)';
      }
    },
    mixins: [powerupsActionsMixins, profilePermissionsMixin],
    props: {
      items: {
        type: Array,
        default: () => []
      },
      loading: {
        type: Boolean,
        required: true
      }
    },
    data: () => ({
      headers: [
        {
          text: '#',
          value: 'id'
        },
        {
          text: 'Título',
          value: 'nome'
        },
        {
          text: 'Mês dos dados',
          value: 'data_registro'
        },
        {
          text: 'Tipo',
          value: 'tipo_sequenciamento'
        },
        {
          text: 'CTMTS',
          value: 'ctmts_selecionados'
        },
        {
          text: 'UNTRMTS',
          value: 'untrmts_selecionados'
        },
        {
          text: 'Status',
          value: 'status'
        },
        {
          sortable: false,
          text: 'Ações',
          value: 'actions',
          class: 'pl-4'
        }
      ],
      search: '',
      dialogCtmtsSelecionados: false,
      dialogCtmtsSelecionadosData: [],
      dialogUntrmtsSelecionados: false,
      dialogUntrmtsSelecionadosData: [],
      dialogDelete: false,
      dialogDeleteData: { id: null },
      loadingLogsTecnicos: {},
      downloadProgressData: {}
    }),
    methods: {
      canExecuteItem(status) {
        return status === 'SUCESSO' || status === 'FALHA';
      },
      executeItem(id) {
        if (!confirm(`Tem certeza que deseja executar novamente o sequenciamento #${id}?`)) {
          return;
        }
        SequenciamentoEletricoService.executar(id)
          .then(() => {
            this.$toast.info('A execução do Sequenciamento Elétrico ocorrerá em instantes. Por favor, aguarde.', '', {
              position: 'topRight',
              timeout: 2000
            });
            this.$emit('rechargeTable');
          })
          .catch(() => {
            this.$toast.error('Erro ao executar o sequenciamento elétrico.', '', {
              position: 'topRight'
            });
          });
      },
      canDeleteItem(item) {
        return item.status === 'AGUARDANDO';
      },
      openDialogCtmtsSelecionados(ctmtsSelecionados) {
        this.dialogCtmtsSelecionadosData = ctmtsSelecionados;
        this.dialogCtmtsSelecionados = true;
      },
      openDialogUntrmtsSelecionados(untrmtsSelecionados) {
        this.dialogUntrmtsSelecionadosData = untrmtsSelecionados;
        this.dialogUntrmtsSelecionados = true;
      },
      openDialogCreationLog(item) {
        this.dialogCreationLog = true;
        this.dialogCreationLogData = {
          username: item.usuario,
          created: item.created
        };
      },
      openDialogDelete(item) {
        this.dialogDelete = true;
        this.dialogDeleteData = {
          id: item.id
        };
      },
      deletarItem(id) {
        SequenciamentoEletricoService.deletar(id)
          .then(() => {
            this.$toast.success('Execução do sequenciamento elétrico removida com sucesso.', '', {
              position: 'topRight'
            });
            this.$emit('rechargeTable');
          })
          .catch((error) => {
            this.$toast.error('Erro ao deletar a execução do sequenciamento elétrico.', '', {
              position: 'topRight'
            });
            console.error(error);
          });
        this.dialogDelete = false;
      },
      baixarLogsTecnicos(sequenciamentoId) {
        this.loadingLogsTecnicos[sequenciamentoId] = true;
        SequenciamentoEletricoService.baixarLogsTecnicos(sequenciamentoId)
          .then((res) => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `logs-tecnicos-sequenciamento-eletrico-${sequenciamentoId}.log`);
            document.body.appendChild(link);
            link.click();
          })
          .catch(() => {
            this.$toast.error('Falha no download dos logs técnicos.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loadingLogsTecnicos[sequenciamentoId] = false));
      }
    }
  };
</script>
